export default "__VITE_ASSET__BgIUP5Uq__"